mapboxgl.accessToken = window.storeLocator.token
let lngLat = window.storeLocator.initLngLat
let locations = null

const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: lngLat,
    zoom: 4,
    scrollZoom: false
})

map.addControl(new mapboxgl.NavigationControl())

const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl
})
map.addControl(geocoder)

const geolocate = new mapboxgl.GeolocateControl()
map.addControl(geolocate)

geocoder.on('result', (event) => {
    console.log(event)
    lngLat = event.result.geometry
    initLocationsData()
})

geolocate.on('geolocate', (event) => {
    lngLat = [event.coords.longitude, event.coords.latitude]
    initLocationsData()
})

const getLoations = async () => {
    const response = await fetch(window.storeLocator.locations)
    const data = await response.json()

    locations = data.map(location => (
        {
            geometry: {
                coordinates: [
                    location.longitude,
                    location.latitude
                ]
            },
            properties: {
                title: location.name,
                address: location.address,
                address2: location.address2,
                city: location.city,
                state: location.state,
                country: location.country,
                zip: location.postalCode,
                email: location.email,
                phone: location.phone,
                website: location.website,
                account_type: location.preferred,
                instagram: location.instagram,
                tiktok: location.tikTok
            }
        }
    ))

    locations = {
        features: locations
    }

    console.log(locations)

    initLocationsData()
}
getLoations()

const initLocationsData = () => {
    let features = locations.features.map(location => {
        const distance = Math.round(turf.distance(location.geometry.coordinates, lngLat))
        return { ...location, distance }
    })

    features = features.sort((a, b) => a.distance - b.distance)

    document.querySelector('#map-card .card-header span').textContent = features.length

    let listItems = ''

    features.forEach((location, index) => {
        const isPremium = location.properties.account_type === true

        const fullAddress = `${location.properties.address}, ${location.properties.address2 ? location.properties.address2 + ', ' : ''} ${location.properties.city}, ${location.properties.state} ${location.properties.zip}`

        listItems += `
            <li class="">
                <button 
                    class=""
                    data-index="${index}">
                    <div class="d-flex align-items-center">
                        <div class="me-3 flex-grow-1">
                            <span class="title fw-500 small text-uppercase lh-sm d-block mb-1" style="color: ${isPremium ? '#7154c5' : ''}">
                                ${location.properties.title}
                            </span>
                            <span class="description d-block mb-3 opacity-50">
                                ${fullAddress}
                            </span>
                            <div class="d-flex">
                                <span class="badge-distance badge">
                                    ${location.distance} miles away
                                </span>
                                <span class="badge ms-2" style="background-color: #d0c6ec" ${isPremium ? '' : 'hidden'}>
                                    Preferred
                                </span>
                            </div>
                        </div>
                        <svg class="flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="${isPremium ? '#7154c5' : 'currentColor'}"" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"/><path d="M12 8l4 4-4 4M8 12h7"/>
                        </svg>
                    </div>
                </button>
            </li>
        `
    })

    document.querySelector('#store-locations-list').innerHTML = ''
    document.querySelector('#store-locations-list').insertAdjacentHTML('afterbegin', listItems)

    // for (const feature of locations) {
    //     const el = document.createElement('div')
    //     el.className = 'mapbox-marker'

    //     new mapboxgl.Marker(el)
    //         .setLngLat(feature.geometry.coordinates)
    //         .setPopup(
    //             new mapboxgl.Popup({ offset: 25 })
    //                 .setHTML(`
    //                     <p class="title">${feature.properties.title}</p>
    //                     <p>${feature.properties.description}</p>
    //                     <a href="" class="">Get Directions</a>
    //                 `)
    //         )
    //         .addTo(map)
    // }

    const featurePopup = (feature) => {
        const isPremium = feature.properties.account_type === true
        const fullAddress = `${feature.properties.address}, ${feature.properties.address2 ? feature.properties.address2 + ', ' : ''} <br> ${feature.properties.city}, ${feature.properties.state} ${feature.properties.zip}`

        return `
            <p class="title text-start">
                ${feature.properties.title}
            </p>
            <p class="mb-4">
                <span class="badge" style="background-color: #d0c6ec" ${isPremium ? '' : 'hidden'}>
                    Preferred Saloon
                </span>
            </p>
            <p>
                ${fullAddress}
            </p>
            <p ${feature.properties.phone ? '' : 'hidden'}>
                Tel: 
                <a href="tel:${feature.properties.phone}" target="_blank">
                    ${feature.properties.phone}
                </a>
            </p>
            <p ${isPremium && feature.properties.website ? '' : 'hidden'}>
                Web: 
                <a href="${feature.properties.website}" target="_blank">
                    ${feature.properties.website}
                </a>
            </p>
            <p ${isPremium && feature.properties.email ? '' : 'hidden'}>
                Email: 
                <a href="mailto:${feature.properties.email}" target="_blank">
                    ${feature.properties.email}
                </a>
            </p>
            <p ${isPremium && feature.properties.instagram ? '' : 'hidden'}>
                Instagram: 
                <a href="https://www.instagram/${feature.properties.instagram}" target="_blank">
                    ${feature.properties.instagram}
                </a>
            </p>
            <p ${isPremium && feature.properties.tiktok ? '' : 'hidden'}>
                TikTok:
                <a href="https://www.tiktok/@${feature.properties.tiktok}" target="_blank">
                    ${feature.properties.tiktok}
                </a>
            </p>
            <hr class="my-4">
            <a 
                href="https://www.google.com/maps/dir/${fullAddress.replaceAll('<br>', '')}" 
                target="_blank" 
                class="btn btn-primary w-100">
                Get Directions
            </a>
        `
    }

    map.on('load', () => {
        // Add a new source from our GeoJSON data and
        // set the 'cluster' option to true. GL-JS will
        // add the point_count property to your source data.
        map.addSource('goldieLockLocations', {
            type: 'geojson',
            // Point to GeoJSON data. This example visualizes all M1.0+ earthquakes
            // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
            // data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson',
            data: locations,
            cluster: true,
            clusterMaxZoom: 14, // Max zoom to cluster points on
            clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
        })

        map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'goldieLockLocations',
            filter: ['has', 'point_count'],
            paint: {
                // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                // with three steps to implement three types of circles:
                'circle-color': [
                    'step',
                    ['get', 'point_count'],
                    '#c5b3a0',
                    100,
                    '#a88d71',
                    250,
                    '#8e7357'
                ],
                'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    20,
                    100,
                    30,
                    250,
                    40
                ]
            }
        })

        map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'goldieLockLocations',
            filter: ['has', 'point_count'],
            layout: {
                'text-field': ['get', 'point_count_abbreviated'],
                'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                'text-size': 12
            },
            paint: {
                'text-color': '#ffffff'
            }
        })

        map.addLayer({
            id: 'unclustered-point',
            type: 'circle',
            source: 'goldieLockLocations',
            filter: ['!', ['has', 'point_count']],
            paint: {
                'circle-color': '#c5b3a0',
                'circle-radius': 10,
                'circle-stroke-width': 2,
                'circle-stroke-color': '#fff'
            }
        })

        // inspect a cluster on click
        map.on('click', 'clusters', (e) => {
            const features = map.queryRenderedFeatures(e.point, {
                layers: ['clusters']
            })
            const clusterId = features[0].properties.cluster_id
            map.getSource('goldieLockLocations').getClusterExpansionZoom(
                clusterId,
                (err, zoom) => {
                    if (err) return
                    map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom
                    })
                }
            )
        })

        // When a click event occurs on a feature in
        // the unclustered-point layer, open a popup at
        // the location of the feature, with
        // description HTML from its properties.
        map.on('click', 'unclustered-point', (e) => {
            console.log(e)
            const feature = e.features[0]
            const coordinates = feature.geometry.coordinates.slice()

            // Ensure that if the map is zoomed out such that
            // multiple copies of the feature are visible, the
            // popup appears over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
            }

            new mapboxgl.Popup({ offset: 5 })
                .setLngLat(coordinates)
                .setHTML(featurePopup(feature))
                .addTo(map)
        })

        map.on('mouseenter', 'clusters', () => {
            map.getCanvas().style.cursor = 'pointer'
        })
        map.on('mouseleave', 'clusters', () => {
            map.getCanvas().style.cursor = ''
        })
    })

    document.querySelectorAll('#store-locations-list button').forEach(btn => {
        btn.addEventListener('click', (e) => {
            document.querySelectorAll('#store-locations-list button').forEach(btn => {
                btn.classList.remove('active')
            })

            btn.classList.add('active')

            const feature = features[Number(btn.dataset.index)]

            map.flyTo({
                center: feature.geometry.coordinates,
                zoom: 14
            })

            document.querySelectorAll('.mapboxgl-popup').forEach((popup) => {
                popup.remove()
            })

            new mapboxgl.Popup({ offset: 25 })
                .setLngLat(feature.geometry.coordinates)
                .setHTML(featurePopup(feature))
                .addTo(map)
        })
    })
}
